export default {
  txz:'提箱站',
  ggcs:'规格参数',
  ckg:'长宽高',
  zztj:'载重体积',
  zzlck:'装载量参考',
  txrq:'提箱日期',
  syxs:'剩余箱数',
  qkxzy:'取空箱资源',
  xs:'箱数',
}
